import React from 'react'
import ItemPopup from '../ItemPopup'
import {Popover, OverlayTrigger} from 'react-bootstrap'

const ItemPopupContainer = ({
  className,
  data,
  id,
  selectedItem,
  handleClose,
  displayField,
  defaultShow,
  placement,
  children,
}) => {
  return (
    <OverlayTrigger
      trigger="click"
      rootClose="true"
      placement={placement}
      defaultShow={defaultShow}
      id={id}
      overlay={
        <Popover>
          <ItemPopup
            auditid={data.id}
            entityid={data.audit_entities_attributes[0].id}
            entityKey={data.audit_entities_attributes[0].entity_key}
            itemid={selectedItem}
            displayField={displayField}
            handleClose={handleClose}
          ></ItemPopup>
        </Popover>
      }
    >
      <div className={className}> {children} </div>
    </OverlayTrigger>
  )
}

export default ItemPopupContainer
